export default __webpack_public_path__ + "static/media/km.c75f417e.svg";